import ErrorsHelper from "@/_helpers/ErrorsHelper.js";
import ModulesConfig from "@/../ModulesConfig";

export default class ModulesLoader {
  constructor(componentReference) {
    this.componentReference = componentReference;
    this.moduleName = "";
  }

  //TODO: adapt this method to get URLS of apps libraries from Keycloack
  //for now we are returning a Promise so later we don't need to change
  //our code based on this method since that API calls return promises
  GetAppsLibraries() {
    return new Promise((resolve) => {
      resolve(ModulesConfig.GetModules());
    });
  }

  InjectBuildInfo(modules, index) {
    let currentModule = modules[index];
    if (currentModule.base.startsWith("$VUE_APP_")) {
      ErrorsHelper.MissingModuleBaseUrl(
        currentModule.moduleName,
        currentModule.base
      );
    }
    const self = this,
      buildInfoPath = `${currentModule.base}build-info.js?${this.uuidv4()}`;

    this.AppendScript(
      buildInfoPath,
      () => {
        currentModule.version = this.extractModuleVersion(currentModule);
        if (index === modules.length - 1)
          self.componentReference.treatModule = 0;
      },
      () => {
        ErrorsHelper.buildInfoNotFound(currentModule);
        currentModule.version = "0.0.0";
        if (index === modules.length - 1)
          self.componentReference.treatModule = 0;
      }
    );
  }

  extractModuleVersion(currentModule) {
    const moduleVersion = window[`${currentModule.moduleName}BuildVersion`];

    if (!moduleVersion) return "0.0.0";

    delete window[`${currentModule.moduleName}BuildVersion`];
    if (moduleVersion.includes("$VUE_APP_")) {
      ErrorsHelper.buildVersionNotFound(currentModule.moduleName);
      return "0.0.0";
    }
    return moduleVersion;
  }

  uuidv4() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
  }

  AddLibrariesToDOM(module) {
    if (module == undefined || module == null) {
      this.componentReference.treatModule = -1;
      return;
    }
    this.moduleName = module.moduleName;
    module.libraries.forEach((library) => {
      this.AddLibraryToDOM(module.base + library, module);
    });
  }

  IgnoreCurrent() {
    const treatModule = this.componentReference.treatModule,
      modules = this.componentReference.modules;
    if (treatModule === -1) return;

    modules[treatModule].isIgnored = true;
    this.componentReference.treatModule = modules[treatModule + 1]
      ? treatModule + 1
      : -1;
  }

  AddLibraryToDOM(path, module) {
    if (module.isIgnored || module.moduleName == null) return;
    const versionedPath = `${path}?v=${module.version}`,
      self = this;
    if (this.IsScript(path))
      this.AppendScript(versionedPath, null, () => {
        ErrorsHelper.unableToLoadLibrary("script", path);
        self.IgnoreCurrent();
        self.RemoveRootElement(module.moduleName);
      });
    else if (this.IsStyle(path))
      this.AppendStyle(versionedPath, null, () => {
        ErrorsHelper.unableToLoadLibrary("style", path, false);
      });
    else
      throw `Unsupported library type: ${path} \nAccepted Libraries: [.js, .css, .js.map] files.`;
  }

  InjectRootElement(moduleName) {
    this.componentReference.rootElements.push({
      id: moduleName,
      page: "/",
      removed: false,
    });
  }

  RemoveRootElement(moduleName) {
    this.componentReference.rootElements.forEach((element) => {
      if (element.id == moduleName) {
        element.removed = true;
      }
    });
  }

  //private methods: in a perfect world
  IsStyle(libraryPath) {
    return libraryPath.endsWith(".css");
  }

  IsScript(libraryPath) {
    return libraryPath.endsWith(".js") || libraryPath.endsWith(".js.map");
  }

  ClearDOM(moduleName, entryPoint = null) {
    document
      .querySelectorAll(`.module-${moduleName}`)
      .forEach((el) => el.remove());

    if (entryPoint !== null) {
      entryPoint._.appContext.app.unmount();
    }
  }

  AppendStyle(url, successCallback = null, failCallback = null) {
    let styles = document.getElementsByTagName("link");

    for (let i = 0; i < styles.length; i++) {
      let style = styles[i];
      if (style.href.indexOf(url) > -1) {
        style.parentElement.removeChild(style);
        break;
      }
    }

    let style = document.createElement("link");

    style.onload = () => {
      this.componentReference.$forceUpdate();
      if (successCallback !== null) successCallback();
    };

    style.onerror = () => {
      if (failCallback !== null) failCallback();
      style.remove();
    };

    style.classList.add(`module-${this.moduleName}`);
    style.href = url;
    style.rel = "stylesheet";

    document.head.insertBefore(style, document.head.firstElementChild);
  }

  AppendScript(url, successCallback = null, failCallback = null) {
    let scripts = document.getElementsByTagName("script");

    for (let i = 0; i < scripts.length; i++) {
      let script = scripts[i];
      if (script.src.indexOf(url) > -1) {
        script.parentElement.removeChild(script);
        break;
      }
    }

    let script = document.createElement("script");

    script.onload = () => {
      this.componentReference.$forceUpdate();
      if (successCallback !== null) successCallback();
    };

    script.onerror = () => {
      if (failCallback !== null) failCallback();
      script.remove();
    };

    script.classList.add(`module-${this.moduleName}`);
    script.src = url;

    document.head.insertBefore(script, document.head.firstElementChild);
  }
}
